var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenTip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6865 3.51466C11.8714 3.33864 12.1175 3.24133 12.3727 3.24326C12.628 3.24519 12.8725 3.34621 13.0548 3.52501C13.237 3.70381 13.3426 3.9464 13.3493 4.20159C13.3561 4.45678 13.2634 4.70461 13.0909 4.89278L7.85404 11.4422C7.76399 11.5391 7.65531 11.617 7.53449 11.671C7.41367 11.725 7.2832 11.7542 7.15087 11.7566C7.01854 11.7591 6.88708 11.7348 6.76435 11.6853C6.64161 11.6358 6.53012 11.562 6.43654 11.4684L2.96366 7.99553C2.86695 7.90541 2.78938 7.79674 2.73558 7.67599C2.68178 7.55524 2.65285 7.42489 2.65051 7.29272C2.64818 7.16055 2.6725 7.02926 2.722 6.90669C2.77151 6.78411 2.8452 6.67277 2.93868 6.5793C3.03215 6.48582 3.1435 6.41213 3.26607 6.36262C3.38864 6.31311 3.51993 6.2888 3.6521 6.29113C3.78427 6.29346 3.91462 6.32239 4.03537 6.3762C4.15612 6.43 4.2648 6.50757 4.35491 6.60428L7.10329 9.35135L11.6616 3.54353C11.6698 3.53343 11.6786 3.52379 11.6879 3.51466H11.6865Z",
    fill: "#76C791"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTip);
export default __webpack_public_path__ + "static/media/green-tip.ca88b880565c7371788d2beeb4f0c931.svg";
export { ForwardRef as ReactComponent };